import { getAllTextNodes } from "../../dom";
import { setEndOfTextNode } from "../../dom/caret";

function getCaretPosition(document) {
  var editor = document.activeElement;
  while (editor && !editor.classList.contains("grigora-richtext-input__field"))
    editor = editor.parentElement;
  if (!editor) return;
  return CaretUtil.getCaretPosition(document, editor);
}

function moveCaretPosition(document, position) {
  if (position !== undefined && position !== null) {
    var editor = document.activeElement;
    while (
      editor &&
      !editor.classList.contains("grigora-richtext-input__field")
    )
      editor = editor.parentElement;
    if (!editor) return false;
    CaretUtil.setCaretPosition(document, editor, position);
  }
  return false;
}

function setEndOfContenteditable(document, contentEditableElement) {
  var range, selection;
  contentEditableElement.focus();

  if (document.createRange) {
    //Firefox, Chrome, Opera, Safari, IE 9+
    range = document.createRange(); //Create a range (a range is a like the selection but invisible)
    range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    selection = document.getSelection(); //get the selection object (allows you to change selection)
    selection.removeAllRanges(); //remove any selections already made
    selection.addRange(range); //make the range you have just created the visible selection
  } else if (document.selection) {
    //IE 8 and lower
    range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
    range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    range.select(); //Select the range (make it the visible selection
  }
}

function setEndOfContenteditableInsideTextNode(
  document,
  contentEditableElement,
) {
  var range, selection;
  contentEditableElement.focus();

  var allTextNodes = getAllTextNodes(contentEditableElement);

  if (allTextNodes.length > 0) {
    setEndOfTextNode(allTextNodes[allTextNodes.length - 1], document);
    return;
  }

  if (document.createRange) {
    //Firefox, Chrome, Opera, Safari, IE 9+
    range = document.createRange(); //Create a range (a range is a like the selection but invisible)
    range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    selection = document.getSelection(); //get the selection object (allows you to change selection)
    selection.removeAllRanges(); //remove any selections already made
    selection.addRange(range); //make the range you have just created the visible selection
  } else if (document.selection) {
    //IE 8 and lower
    range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
    range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    range.select(); //Select the range (make it the visible selection
  }
}

function pasteHtmlAtCaret(document, html, keepCaretAtStart = false) {
  var sel, range;
  if (document.getSelection) {
    // IE9 and non-IE
    sel = document.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();

      // Range.createContextualFragment() would be useful here but is
      // non-standard and not supported in all browsers (IE9, for one)
      var el = document.createElement("div");
      el.innerHTML = html;
      var frag = document.createDocumentFragment(),
        node,
        lastNode,
        firstNode;
      while ((node = el.firstChild)) {
        lastNode = frag.appendChild(node);
        if (!firstNode) {
          firstNode = lastNode;
        }
      }
      range.insertNode(frag);

      if (keepCaretAtStart && firstNode) {
        range = range.cloneRange();
        range.setStart(firstNode, 0);
        range.setEnd(firstNode, 0);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
        return;
      }

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type != "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

function pasteTextAtCaret(document, text, keepCaretAtStart = false) {
  var sel, range;
  if (document.getSelection) {
    // IE9 and non-IE
    sel = document.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();

      // Create a text node instead of parsing HTML
      var textNode = document.createTextNode(text);
      range.insertNode(textNode);

      // Handle caret position
      if (keepCaretAtStart) {
        range = range.cloneRange();
        range.setStart(textNode, 0);
        range.setEnd(textNode, 0);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
        return;
      }

      // Preserve the selection at the end of inserted text
      range = range.cloneRange();
      range.setStartAfter(textNode);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  } else if (document.selection && document.selection.type != "Control") {
    // IE < 9
    document.selection.createRange().text = text;
  }
}

// CaretUtil library, based on
// https://stackoverflow.com/questions/6249095/41034697#41034697
var CaretUtil = {};

/**
 * Set the caret position inside a contentEditable container
 */
CaretUtil.setCaretPosition = function (document, container, position) {
  if (position >= 0) {
    var selection = document.getSelection();
    var range = CaretUtil.createRange(document, container, { count: position });
    if (range != null) {
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
};

/**
 * Get the current caret position inside a contentEditable container
 */
CaretUtil.getCaretPosition = function (document, container) {
  var selection = document.getSelection();
  var charCount = -1;
  var node;
  if (selection.focusNode != null) {
    if (CaretUtil.isDescendantOf(selection.focusNode, container)) {
      node = selection.focusNode;
      charCount = selection.focusOffset;
      while (node != null) {
        if (node == container) {
          break;
        }
        if (node.previousSibling != null) {
          node = node.previousSibling;
          charCount += node.textContent.length;
        } else {
          node = node.parentNode;
          if (node == null) {
            break;
          }
        }
      }
    }
  }
  return charCount;
};

/**
 * Returns true if the node is a descendant (or equal to) a parent
 */
CaretUtil.isDescendantOf = function (node, parent) {
  while (node != null) {
    if (node == parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

CaretUtil.createRange = function (document, node, chars, range) {
  if (range == null) {
    range = document.createRange();
    range.selectNode(node);
    range.setStart(node, 0);
  }
  if (chars.count == 0) {
    range.setEnd(node, chars.count);
  } else if (node != null && chars.count > 0) {
    if (node.nodeType == 3) {
      if (node.textContent.length < chars.count) {
        chars.count -= node.textContent.length;
      } else {
        range.setEnd(node, chars.count);
        chars.count = 0;
      }
    } else {
      var _g = 0;
      var _g1 = node.childNodes.length;
      while (_g < _g1) {
        var lp = _g++;
        range = CaretUtil.createRange(
          document,
          node.childNodes[lp],
          chars,
          range,
        );
        if (chars.count == 0) {
          break;
        }
      }
    }
  }
  return range;
};

function isCaretStartOrEnd(document, el) {
  var atStart = false,
    atEnd = false;
  var selRange, testRange;
  if (document.getSelection) {
    var sel = document.getSelection();
    if (sel.rangeCount) {
      selRange = sel.getRangeAt(0);
      testRange = selRange.cloneRange();

      testRange.selectNodeContents(el);
      testRange.setEnd(selRange.startContainer, selRange.startOffset);
      atStart = testRange.toString() == "" || testRange.toString() == " ";

      testRange.selectNodeContents(el);
      testRange.setStart(selRange.endContainer, selRange.endOffset);
      atEnd = testRange.toString() == "" || testRange.toString() == " ";
    }
  } else if (document.selection && document.selection.type != "Control") {
    selRange = document.selection.createRange();
    testRange = selRange.duplicate();

    testRange.moveToElementText(el);
    testRange.setEndPoint("EndToStart", selRange);
    atStart = testRange.toString() == "" || testRange.toString() == " ";

    testRange.moveToElementText(el);
    testRange.setEndPoint("StartToEnd", selRange);
    atEnd = testRange.toString() == "" || testRange.toString() == " ";
  }

  return {
    atStart: atStart,
    atEnd: atEnd,
  };
}

export {
  getCaretPosition,
  moveCaretPosition,
  pasteHtmlAtCaret,
  pasteTextAtCaret,
  isCaretStartOrEnd,
  setEndOfContenteditable,
  setEndOfContenteditableInsideTextNode,
};
